import React, {useEffect, useState} from "react";
import {Switch, Route,useHistory} from "react-router-dom";
import Login from "../components/Login/Login";
import LoginRegistration from "../components/Login/LoginRegistration";
import LoginAccountExists from "../components/Login/LoginAccountExists";
import {
    idpLoginReset, resendConfirmationCodeForSocialLoginReset,
    getConfirmationCodeForSocialLoginReset, confirmSocialLoginAccountAccountExistsReset,
    confirmSocialLoginAccountReset
} from "../actions/security";
import { connect } from 'react-redux';
import { Alert as MuiAlert} from '@material-ui/lab';
import {Snackbar} from '@material-ui/core';
import { setModal } from "../actions/app";
import LoginConfirmation from "../components/Login/LoginConfirmation";
import {setLoadingSpinnerOpen} from '../actions/loadingSpinner';

const Alert = props => {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
};


export const loginRoutes = {
    root:                       '/login',
    confirmation:               '/login/social/confirmation',
    registration:               '/login/social/registration',
    accountExists:              '/login/social/account-exists',
    redirect:                   '/login/idp-redirect'
}


const LoginRoute = ({
    idpLoginSuccess,
    idpLoginError,
    idpLoginErrorResponse,
    idpLoginReset,
    idpLoginErrorIdpService,

    setLoadingSpinnerOpen,

    getConfirmationCodeForSocialLoginReset,
    getConfirmationCodeForSocialLoginSuccess,
    getConfirmationCodeForSocialLoginError,
    getConfirmationCodeForSocialLoginErrorStatus,

    confirmSocialLoginAccountSuccess,
    confirmSocialLoginAccountError,
    confirmSocialLoginAccountRecaptchaToken,
    confirmSocialLoginAccountErrorResponse,

    confirmSocialLoginAccountAccountExistsSuccess,

    setModal,

    loginStep1ConfirmationCodeRedirect,

    loginStep1ConfirmationCodeSuccess,
    loginStep1ConfirmationCodeError,

    resendConfirmationCodeForSocialLoginSuccess,
    resendConfirmationCodeForSocialLoginError,
    resendConfirmationCodeForSocialLoginReset,

}) => {
    const history = useHistory();
    const [userData, setUserData] = useState({});
    const [errorMessage, setErrorMessage] = useState(null);

    const handleAlertClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setErrorMessage(null);
    };

    useEffect(() => {
        // On page load, redirect to root so be sure all necessary data is set up
        history.push(loginRoutes.root)
    }, [history]);

    useEffect(() => {
        if (loginStep1ConfirmationCodeSuccess) {
            // Redirect to code confirmation page
            window.location.href = loginStep1ConfirmationCodeRedirect
        }
    }, [loginStep1ConfirmationCodeSuccess, loginStep1ConfirmationCodeRedirect]);

    useEffect(() => {
        if (loginStep1ConfirmationCodeError) {
            // Error occurred when sending code
            setErrorMessage('There was an error sending the login code. Are you sure the number is correct?')
            setModal('login-error-modal')
        }
    }, [loginStep1ConfirmationCodeError, setModal]);

    useEffect(() => {
        if (confirmSocialLoginAccountError) {
            setLoadingSpinnerOpen(false);
            confirmSocialLoginAccountReset();

            if (confirmSocialLoginAccountErrorResponse.response.status === 409) {
                setErrorMessage("A user with this information already exists. Please login as that user and continue.");
                history.push('/login/social/registration');
            } else {
                setErrorMessage('The provided code did not match our records. Please try again.');
            }
        }
        // eslint-disable-next-line
    }, [confirmSocialLoginAccountError, setLoadingSpinnerOpen]);


    useEffect(() => {
        if (idpLoginSuccess) {
            // User is successfully logged in
            window.location.href = '/secure/account/received';
            idpLoginReset();
        }
    }, [idpLoginSuccess, idpLoginReset]);

    useEffect(() => {
        if (idpLoginError) {

            // attempt to login with social, and receive a 404. Move to registration page
            if (idpLoginErrorResponse?.status === 404) {
                setUserData({
                    ...userData,
                    email: idpLoginErrorResponse.data.data.email,
                    idp_token: idpLoginErrorResponse.data.data.idp_token,
                    mobile: idpLoginErrorResponse.data.data.mobile,
                    name: idpLoginErrorResponse.data.data.name,
                    surname: idpLoginErrorResponse.data.data.surname,
                    idp_service: idpLoginErrorIdpService
                });
                history.push(`${loginRoutes.registration}`);
            } else {
                // show generic error for social login error
                setErrorMessage("There was an error connecting to your social account. Please try again later or contact customer support")
            }
            setLoadingSpinnerOpen(false);
            idpLoginReset();
        }
        // eslint-disable-next-line
    }, [idpLoginError, idpLoginReset]);


    useEffect(() => {
        if (getConfirmationCodeForSocialLoginSuccess) {
            // user doesnt exist... need to register for first time
            setLoadingSpinnerOpen(false);
            history.push(`${loginRoutes.confirmation}/${userData.mobile.replace(/\D/g, '')}`);
            getConfirmationCodeForSocialLoginReset();
        }
        // eslint-disable-next-line
    }, [getConfirmationCodeForSocialLoginSuccess]);

    useEffect(() => {
        if (getConfirmationCodeForSocialLoginError) {
            if (getConfirmationCodeForSocialLoginErrorStatus === 409) {
                // user already exists. Need to show them it already exists page
                getConfirmationCodeForSocialLoginReset();
                setLoadingSpinnerOpen(false);
                history.push(`${loginRoutes.accountExists}?mobile=${userData.mobile.replace(/\D/g, '')}`)
                return;
            }
            setErrorMessage("There was an error sending the confirmation code. Please try again later or contact customer support");
            setLoadingSpinnerOpen(false);
        }
        // eslint-disable-next-line
    }, [getConfirmationCodeForSocialLoginError]);

    useEffect(() => {
        if (resendConfirmationCodeForSocialLoginSuccess) {
            // user doesnt exist... need to register for first time
            setLoadingSpinnerOpen(false);
            history.push(`${loginRoutes.confirmation}/${userData.mobile.replace(/\D/g, '')}?msg=resend-success`);
            resendConfirmationCodeForSocialLoginReset();
        }
        // eslint-disable-next-line
    }, [resendConfirmationCodeForSocialLoginSuccess]);

    useEffect(() => {
        if (resendConfirmationCodeForSocialLoginError) {
            setErrorMessage("There was an error resending the verification code. Please try again later or contact customer support");
            resendConfirmationCodeForSocialLoginReset();
        }
        // eslint-disable-next-line
    }, [resendConfirmationCodeForSocialLoginError]);



    useEffect(() => {
        if (confirmSocialLoginAccountAccountExistsSuccess) {
            window.location.href = '/secure/account/profile';
            confirmSocialLoginAccountAccountExistsReset();
        }
        // eslint-disable-next-line
    }, [confirmSocialLoginAccountAccountExistsSuccess]);


    return (
        <>

            <Switch>
                {/*Start here*/}
                <Route exact path={loginRoutes.root}>
                    <Login />
                </Route>

                {/*go here if the social login is not connected to an account yet*/}
                <Route exact path={loginRoutes.registration}>
                    <LoginRegistration userData={userData} setUserData={setUserData} />
                </Route>

                {/*Go here if the account does not already exist*/}
                <Route exact path={loginRoutes.accountExists}>
                    <LoginAccountExists />
                </Route>

                {/*Go here if the account does not already exist*/}
                <Route exact path={`${loginRoutes.confirmation}/:mobile`}>
                    <LoginConfirmation userData={userData} />
                </Route>
            </Switch>

            <Snackbar
                autoHideDuration={8000}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                open={!!errorMessage} onClose={handleAlertClose}
            >
                <Alert onClose={handleAlertClose} severity="error">{errorMessage}</Alert>
            </Snackbar>
        </>
    )
}

export default connect(
    (state) => ({
        idpLoginSuccess: state.security.idpLoginSuccess,
        idpLoginError: state.security.idpLoginError,
        idpLoginErrorResponse: state.security.idpLoginErrorResponse,
        idpLoginErrorIdpService: state.security.idpLoginErrorIdpService,
        resendConfirmationCodeForSocialLoginSuccess: state.security.resendConfirmationCodeForSocialLoginSuccess,
        resendConfirmationCodeForSocialLoginError: state.security.resendConfirmationCodeForSocialLoginError,
        getConfirmationCodeForSocialLoginSuccess: state.security.getConfirmationCodeForSocialLoginSuccess,
        getConfirmationCodeForSocialLoginError: state.security.getConfirmationCodeForSocialLoginError,
        getConfirmationCodeForSocialLoginErrorStatus: state.security.getConfirmationCodeForSocialLoginErrorStatus,
        confirmSocialLoginAccountSuccess: state.security.confirmSocialLoginAccountSuccess,
        confirmSocialLoginAccountError: state.security.confirmSocialLoginAccountError,
        confirmSocialLoginAccountAccountExistsSuccess: state.security.confirmSocialLoginAccountAccountExistsSuccess,
        loginStep1ConfirmationCodeSuccess: state.security.loginStep1ConfirmationCodeSuccess,
        loginStep1ConfirmationCodeError: state.security.loginStep1ConfirmationCodeError,
        loginStep1ConfirmationCodeRedirect: state.security.loginStep1ConfirmationCodeRedirect,
        confirmSocialLoginAccountRecaptchaToken: state.security.confirmSocialLoginAccountRecaptchaToken,
        confirmSocialLoginAccountErrorResponse: state.security.confirmSocialLoginAccountErrorResponse
    }),
    {
        setLoadingSpinnerOpen,
        setModal,
        idpLoginReset,
        getConfirmationCodeForSocialLoginReset,
        confirmSocialLoginAccountAccountExistsReset,
        resendConfirmationCodeForSocialLoginReset
    }
)(LoginRoute);